import { EMPTY_STRING } from 'constants/MeshbotConstant';

import { getUserCodesItem } from './getUserCodesItem';

/**
 * Returns the id of the device's "user_codes" item (found by name), or an empty string.
 * @param {Array} items - controller items
 * @param {string} deviceId - device id
 * @returns {string}
 */
export const getUserCodesItemIdByDevice = (items, deviceId) => {
    return getUserCodesItem(items, deviceId)?._id || EMPTY_STRING;
};
